/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressAutocompleteRequest } from '../../models/address-autocomplete-request';
import { AddressAutocompleteResponse } from '../../models/address-autocomplete-response';

export interface AutocompleteUsAddress$Params {
      body: AddressAutocompleteRequest
}

export function autocompleteUsAddress(http: HttpClient, rootUrl: string, params: AutocompleteUsAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AddressAutocompleteResponse>>> {
  const rb = new RequestBuilder(rootUrl, autocompleteUsAddress.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AddressAutocompleteResponse>>;
    })
  );
}

autocompleteUsAddress.PATH = '/address-validation/autocomplete-us';
